/**
 * Get viewport dimensions
 * @returns Object with viewport width, height, and device pixel ratio
 */
export const getViewportDimensions = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
  devicePixelRatio: window.devicePixelRatio || 1,
});
